import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) =>({
  root: {
    alignSelf: 'center',
    paddingLeft: '20px',
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: [
      'Montserrat', 
      'sans-serif',
    ].join(','),
  },

  paper: {
    '& > *': {
   
      margin: theme.spacing(0),
      width: theme.spacing(16),
      height: theme.spacing(16),
    },
  },

  title: {
    cursor: 'pointer',
    fontSize: '15px',
    paddingLeft: '8px',
    '&:hover': {
      color: '#DC251A'
    },
   
  },

  titleclicked: {
    backgroundColor: '#DC251A',
    color: '#fff',
    '&:hover': {
        color: '#FFF'
      }
  },

  ddownmenu: {
    visibility: 'hidden',
    opacity: 0,
    transform: "translateY(-2em)",
    padding: 0,
    marginLeft: '-1px',
    width: '140px',
    position: 'absolute',
    listStyle: 'none',
    textAlign: 'start',
    transition: theme.transitions.create('all', {easing: 'ease-in-out', duration: '0.3s', delay: '0s'}),
    '& li': {
      background: '#fff',
      cursor: 'pointer',
      fontWeight: 550,
      fontFamily: [
        'Montserrat', 
        'sans-serif',
      ].join(','),
      '&:hover': {
        background: '#F2F2F2'
      }
    }
    
  },

  clicked: {
    transition: theme.transitions.create('all', {delay: '0s'}),
    visibility: 'visible',
    transform: "translateY(0)",
    opacity: 1,
    zIndex: 1  
},

  selected: {
    color: '#DC251A'
    },

  dropdownlink: {
      display: 'block',
      padding: '5px',
      height: '100%',
      width: '100%',
      textDecoration: 'none',
      borderBottom: '1px solid #F2F2F2'
    }
}));